var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('strong', [_vm._v("Reden")])]), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('strong', [_vm._v("Probeer automatisch opnieuw toe te wijzen")])]), _c('b-col', {
    attrs: {
      "cols": "1"
    }
  })], 1), _c('Draggable', {
    attrs: {
      "group": _vm.randomGroupId
    },
    on: {
      "end": function ($event) {
        return _vm.$emit('input', _vm.value);
      }
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.value, function (unableToShipReason, index) {
    return _c('b-row', {
      key: index,
      staticClass: "mt-3 draggable"
    }, [_c('b-col', {
      attrs: {
        "cols": "9"
      }
    }, [_c('font-awesome-icon', {
      staticClass: "draggable-icon d-inline-block text-info mr-2",
      attrs: {
        "icon": "grip-vertical"
      }
    }), _c('b-input', {
      staticClass: "d-inline-block",
      staticStyle: {
        "width": "calc(100% - 20px)"
      },
      attrs: {
        "size": "sm",
        "disabled": _vm.disabled
      },
      model: {
        value: unableToShipReason.description,
        callback: function ($$v) {
          _vm.$set(unableToShipReason, "description", $$v);
        },
        expression: "unableToShipReason.description"
      }
    })], 1), _c('b-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('b-checkbox', {
      attrs: {
        "switch": "",
        "size": "lg",
        "disabled": _vm.disabled
      },
      model: {
        value: unableToShipReason.isAutoReassignable,
        callback: function ($$v) {
          _vm.$set(unableToShipReason, "isAutoReassignable", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "unableToShipReason.isAutoReassignable"
      }
    })], 1), _c('b-col', {
      attrs: {
        "cols": "1"
      }
    }, [_c('b-button', {
      attrs: {
        "variant": "danger",
        "size": "sm",
        "disabled": _vm.disabled
      },
      on: {
        "click": function ($event) {
          return _vm.removeReason(index);
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "trash"
      }
    })], 1)], 1)], 1);
  }), 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.addReason.apply(null, arguments);
      }
    }
  }, [_c('b-input', {
    class: {
      'border-warning': _vm.newUnableToShipReason.description.length
    },
    staticStyle: {
      "width": "calc(100% - 20px)",
      "margin-left": "18px"
    },
    attrs: {
      "placeholder": "Voer een reden in",
      "size": "sm",
      "disabled": _vm.disabled
    },
    on: {
      "blur": _vm.addReason
    },
    model: {
      value: _vm.newUnableToShipReason.description,
      callback: function ($$v) {
        _vm.$set(_vm.newUnableToShipReason, "description", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "newUnableToShipReason.description"
    }
  })], 1)]), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('b-checkbox', {
    attrs: {
      "switch": "",
      "size": "lg"
    },
    model: {
      value: _vm.newUnableToShipReason.isAutoReassignable,
      callback: function ($$v) {
        _vm.$set(_vm.newUnableToShipReason, "isAutoReassignable", $$v);
      },
      expression: "newUnableToShipReason.isAutoReassignable"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Toevoegen`,
      expression: "`Toevoegen`"
    }],
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.addReason
    }
  }, [_vm._v("+")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }